import React from 'react';
import PropTypes from 'prop-types';
import './mouse.css';

const Mouse = ({ up, down, className }) => (
  <div className={`mousewrapper ${className}`}>
    <div className="up" style={{ display: up ? 'block' : 'none' }}>
      <span className="unu" />
      <span className="doi" />
      <span className="trei" />
    </div>
    <div className="mouse"><div className="wheel" /></div>
    <div className="down" style={{ display: down ? 'block' : 'none' }}>
      <span className="unu" />
      <span className="doi" />
      <span className="trei" />
    </div>
  </div>
);

Mouse.propTypes = {
  up: PropTypes.bool,
  down: PropTypes.bool,
  className: PropTypes.string,
};

Mouse.defaultProps = {
  up: false,
  down: false,
  className: '',
};

export default Mouse;



// WEBPACK FOOTER //
// ./src/components/Mouse/index.js